import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { useCurrentScope } from '../../../shared/scope/useCurrentScope.js';
import {
  conversionDigestQueryKey,
  getConversionDigestSettings,
  patchConversionDigestSettings,
  type ConversionDigestSettings,
  type UpdateConversionDigestSettings,
} from '../api/conversion-digest.client.js';

export function useConversionDigestSettings() {
  const scope = useCurrentScope();
  return useQuery({
    queryKey: conversionDigestQueryKey(scope?.workspaceId ?? 'anonymous'),
    queryFn: getConversionDigestSettings,
    enabled: scope !== null,
  });
}

export function useConversionDigestMutation() {
  const scope = useCurrentScope();
  const client = useQueryClient();
  const key = conversionDigestQueryKey(scope?.workspaceId ?? 'anonymous');
  return useMutation({
    mutationFn: (input: UpdateConversionDigestSettings) => patchConversionDigestSettings(input),
    onSuccess: async (data: ConversionDigestSettings) => {
      client.setQueryData(key, data);
      await client.invalidateQueries({ queryKey: key });
    },
  });
}
